import { render, staticRenderFns } from "./AdminVolunteers.vue?vue&type=template&id=4f99d1db&scoped=true"
import script from "./AdminVolunteers.vue?vue&type=script&lang=js"
export * from "./AdminVolunteers.vue?vue&type=script&lang=js"
import style0 from "./AdminVolunteers.vue?vue&type=style&index=0&id=4f99d1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99d1db",
  null
  
)

export default component.exports